var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13H3C1.89543 13 1 13.8954 1 15V21C1 22.1046 1.89543 23 3 23H23C24.1046 23 25 22.1046 25 21V14.9994C25 13.8951 24.1049 12.9997 23.0006 12.9994L20 12.9985M5.92002 10.5474C7.89658 8.90106 10.3876 7.99951 12.96 7.99951C15.5324 7.99951 18.0235 8.90106 20 10.5474M2.34 6.99735C5.26242 4.42132 9.0243 3 12.92 3C16.8157 3 20.5776 4.42132 23.5 6.99735M9.45005 14.1073C10.4652 13.386 11.6797 12.9985 12.925 12.9985C14.1704 12.9985 15.3848 13.386 16.4 14.1073M12.92 17.9973H12.93",
    stroke: "#272638",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.ea8db3c2509b68dd02021916c87720e9.svg";
export { ForwardRef as ReactComponent };